import { render, staticRenderFns } from "./Studentlist.vue?vue&type=template&id=19bb0fb5&scoped=true"
import script from "./Studentlist.vue?vue&type=script&lang=js"
export * from "./Studentlist.vue?vue&type=script&lang=js"
import style0 from "./Studentlist.vue?vue&type=style&index=0&id=19bb0fb5&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19bb0fb5",
  null
  
)

export default component.exports